<template>
  <modal
    :name="name"
    :adaptive="true"
    :max-width="maxWidth"
    width="100%"
    :focus-trap="true"
    :scrollable="true"
    height="auto"
    :click-to-close="options.clickToClose"
    :classes="['modal', { 'modal--mobile': mq('to-small') }]"
    @closed="closed()">
    <button v-if="options.showClose" class="modal__close-button" @click.stop="$modal.hide(name)">
      <oie-base-icon icon="close" size="l"></oie-base-icon>
    </button>

    <div class="modal__body">
      <slot :options="options"></slot>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    maxWidth: {
      type: Number,
      default: 800
    },
    clickToClose: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    options: {}
  }),
  mounted() {
    this.options = { showClose: this.showClose, clickToClose: this.clickToClose }
    this.subscribe(`modal.show.${this.name}`, (data) => {
      document.querySelector('body').style.overflowY = 'hidden'
      this.options = { ...this.options, ...data, name: this.name }
      this.$modal.show(this.name)
    })
    this.subscribe(`modal.hide.${this.name}`, () => {
      document.querySelector('body').style.overflowY = 'auto'
      this.$modal.hide(this.name)
    })
  },
  methods: {
    closed(event) {
      document.querySelector('body').style.overflowY = 'auto'
      if (this.options.resetFunction) {
        this.options.resetFunction()
      }
    }
  }
}
</script>

<style lang="scss">
.wrapper .v--modal-overlay {
  background-color: rgba(51, 51, 51, .50) !important;
  z-index: 1000 !important;
}

.modal {
  top: 3rem !important;
  background-color: color(background-white);
  box-shadow: 2px 2px 16px 0 rgba(0, 0, 0, .5);
}

.modal--mobile {
  top: 0 !important;
}

.modal__close-button {
  @include reset-button;
  position: absolute;
  top: measure(quarter);
  right: measure(quarter);
  width: 1.875rem;
  height: 1.875rem;
  color: color(gray-2);

  > svg {
    width: 100%;
    height: 100%;
  }
}

.modal__body {
  padding: measure(full);
  color: color(text);
  text-align: left;
}

.modal__header {
  @include h2-semi-bold;
  margin-top: 0;
  margin-bottom: measure(half);
  color: color(text-blue);
}

.modal__text {
  @include body-semi-bold;
  display: block;
  margin: 0;
  margin-bottom: measure(full);
  padding: 0;
}

.modal__spacer {
  margin-bottom: measure(full);
}
</style>
